import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
} from '../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Emitter3oauzcbmv9irf as Emitter } from '../../../../reactive/com/lightningkite/reactive/core/processes.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { BaseReactive302n39o7i5yop as BaseReactive } from '../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.sg5_1.qg5_1(new (Engine())($this.sg5_1, $this$launch), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = $this.tg5_1.qg5_1(new (Engine())($this.tg5_1, $this$launch), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var EngineClass;
function Engine() {
  if (EngineClass === VOID) {
    class $ {
      constructor($outer, scope) {
        this.vg5_1 = $outer;
        this.ug5_1 = scope;
      }
      eaq(value) {
        this.vg5_1.pah(_ReactiveState___init__impl__fvdp9b(value));
      }
      ea2() {
        return this.ug5_1.ea2();
      }
    }
    initMetadataForClass($, 'Engine', VOID, VOID, [Emitter(), CoroutineScope()]);
    EngineClass = $;
  }
  return EngineClass;
}
var RestartableProcess$activate$slambdaClass;
function RestartableProcess$activate$slambda() {
  if (RestartableProcess$activate$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.sg5_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    RestartableProcess$activate$slambdaClass = $;
  }
  return RestartableProcess$activate$slambdaClass;
}
function RestartableProcess$activate$slambda_0(this$0) {
  var i = new (RestartableProcess$activate$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var RestartableProcess$restart$slambdaClass;
function RestartableProcess$restart$slambda() {
  if (RestartableProcess$restart$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.tg5_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    RestartableProcess$restart$slambdaClass = $;
  }
  return RestartableProcess$restart$slambdaClass;
}
function RestartableProcess$restart$slambda_0(this$0) {
  var i = new (RestartableProcess$restart$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var RestartableProcessClass;
function RestartableProcess() {
  if (RestartableProcessClass === VOID) {
    class $ extends BaseReactive() {
      static wg5(scope, calculation) {
        scope = scope === VOID ? get_AppScope() : scope;
        var $this = this.gal();
        $this.pg5_1 = scope;
        $this.qg5_1 = calculation;
        $this.rg5_1 = null;
        return $this;
      }
      ial() {
        this.pah(Companion_getInstance().mah_1);
        var tmp = this;
        tmp.rg5_1 = launch(this.pg5_1, VOID, VOID, RestartableProcess$activate$slambda_0(this));
      }
      jal() {
        var tmp0_safe_receiver = this.rg5_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.ma3();
        }
        this.rg5_1 = null;
      }
      xg5() {
        var tmp0_safe_receiver = this.rg5_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.ma3();
        }
        var tmp = this;
        tmp.rg5_1 = launch(this.pg5_1, VOID, VOID, RestartableProcess$restart$slambda_0(this));
      }
    }
    initMetadataForClass($, 'RestartableProcess');
    RestartableProcessClass = $;
  }
  return RestartableProcessClass;
}
//region block: exports
export {
  RestartableProcess as RestartableProcess1yhsc2b2m6aws,
};
//endregion

//# sourceMappingURL=RestartableProcess.mjs.map
